import { render } from "./Spoiler.vue?vue&type=template&id=609df60f&ts=true"
import script from "./Spoiler.vue?vue&type=script&lang=ts"
export * from "./Spoiler.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\projects\\vue-spoiler\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__